



















































































import { Component } from 'vue-property-decorator';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import OrganisationEdit from '@/components/Customers/Organisations/OrganisationEdit.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'OrganisationDetails', components: { OrganisationEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get organisation() {
        return OrganisationModule.organisation;
    }

}
